import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { Spinner } from "./components/ui";
import Layout from "./components/Layout";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Customers from "./pages/Customers";
import CustomerNew from "./pages/CustomerNew";
import CustomerDetail from "./pages/CustomerDetail";
import Meetings from "./pages/Meetings";
import MeetingNew from "./pages/MeetingNew";
import MeetingDetail from "./pages/MeetingDetail";
import Quotes from "./pages/Quotes";
import QuoteNew from "./pages/QuoteNew";
import QuoteDetail from "./pages/QuoteDetail";
import InitialDocs from "./pages/InitialDocs";
import ShareLinks from "./pages/ShareLinks";
import Team from "./pages/Team";
import Sheets from "./pages/Sheets";
import More from "./pages/More";
import BlockedSlots from "./pages/BlockedSlots";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}><Spinner /></div>;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/customers" element={<Protected><Customers /></Protected>} />
          <Route path="/customers/new" element={<Protected><CustomerNew /></Protected>} />
          <Route path="/customers/:id" element={<Protected><CustomerDetail /></Protected>} />
          <Route path="/meetings" element={<Protected><Meetings /></Protected>} />
          <Route path="/meetings/new" element={<Protected><MeetingNew /></Protected>} />
          <Route path="/meetings/:id" element={<Protected><MeetingDetail /></Protected>} />
          <Route path="/quotes" element={<Protected><Quotes /></Protected>} />
          <Route path="/quotes/new" element={<Protected><QuoteNew /></Protected>} />
          <Route path="/quotes/:id" element={<Protected><QuoteDetail /></Protected>} />
          <Route path="/initial-docs" element={<Protected><InitialDocs /></Protected>} />
          <Route path="/share-links" element={<Protected><ShareLinks /></Protected>} />
          <Route path="/team" element={<Protected><Team /></Protected>} />
          <Route path="/sheets" element={<Protected><Sheets /></Protected>} />
          <Route path="/blocked-slots" element={<Protected><BlockedSlots /></Protected>} />
          <Route path="/more" element={<Protected><More /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
